// noinspection DuplicatedCode

import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Skeltons from "../../../components/loading/Skeltons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Card from "@material-tailwind/react/Card";
// import { SearchBarSmall, SearchBarSmallV2 } from "../form/SearchBar";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { useMutation } from "@tanstack/react-query";
import {
  fetchPost,
  fetchPostSilance,
  fetchGet,
  fetchPostMultipartSeaweed,
} from "../../../fetchers";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import { alertService } from "../../../../services/AlertService";

// import Loading from "../../../../components/loading/Loading";
import { TextEditor } from "./TextEditor";

import {
  GetKaryawanMinV2,
  getMinKaryawan,
  karyawanSelector,
} from "../../hrd/karyawan/karyawanSlice";
import {
  //   getIzinTransaksi,
  //   insertIzinTransaksi,
  izinTransaksiSelector,
  updateIzinTransaksi,
} from "../../hrd/transaksi/izin/izinTransaksiSlice";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../hrd/karyawan/KaryawanSelector";
import { bagianSelector, getMinBagian } from "../../master/bagian/bagianSlice";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { convertToRaw, EditorState } from "draft-js";

const MemoPage = ({}) => {
  let initialState = {
    Bulan: new Date(),
    to: [], // Changed to array to support multiple select
  };
  const mutation = useMutation((param) => fetchGet("getInternalMemo", param));

  const mutationAdd = useMutation((param) =>
    fetchPost("InsertInternalMemo", param)
  );

  const validations = [
    ({ to }) => (to && to.length > 0) || { to: "To wajib diisi" }, // Updated validation for array
    ({ Subject }) => isRequired(Subject) || { Subject: "Subject wajib diisi" },
    ({ Attachment }) =>
      isRequired(Attachment) || { Attachment: "Attachment wajib diisi" },
    ({ description }) =>
      isRequired(description) || { Description: "Description wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
    changeArrayHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dateChanged, setDateChanged] = useState(false);
  const [firstLoading, setFirstLoading] = useState(false);
  const [start, setStart] = useState(0);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [search, setSearch] = useState("");
  const [searchFetch, setSearchFetch] = useState(false);
  const [updateFetch, setUpdateFetch] = useState(false);

  const [insertFetch, setInsertFetch] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );
  const userString = localStorage.getItem("user");
  let authUser = null;

  if (userString) {
    try {
      const userObj = JSON.parse(userString);
      authUser = userObj?.Nik; // "SO-20220601"
    } catch (err) {
      console.error("Failed to parse user from localStorage", err);
    }
  }

  useEffect(() => {
    const formData = {
      start: start,
      count: count,
      search: "",
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      user: authUser, // Kirim user ID ke backend
      showall: "false", // Default hanya tampilkan memo terkait user
    };
    mutation.mutate(formData);
  }, []);

  const reapprove = () => {
    mutation.mutate({
      start: start,
      count: count,
      search: search,
    });
  };

  function handleSearch(searchValue) {
    let params = {
      start: 0,
      count: 10,
      search: searchValue,
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
    };
    mutation.mutate(params);
    setStart(0);
    setCount(10);
    setSearch(searchValue);
    setSearchFetch(true);
  }

  function ClickAdd() {
    setShowModalAdd(true);
    clearHandler();
    setButtonTouched(false);
    dispatch(getMinBagian({ search: "" }));
    dispatch(GetKaryawanMinV2({ search: "" }));
  }

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      console.log(currentData);
    }
  }, [showModalEdit]);

  const Kirim = () => {
    if (values["NamaFile"]) {
      try {
        const { v4: uuidv4 } = require("uuid");
        const uuid = uuidv4();
        let formData = new FormData();
        const nama = uuid + "-" + values["NamaFile"].name.replaceAll(" ", "_");
        formData.append("file", values["NamaFile"], nama);
        mutationFile.mutate(formData);
        values["NamaFile"] = nama;
      } catch (error) {
        console.log(error);
      }
    }

    // Siapkan data yang akan dikirim
    const memoData = {
      to: values.to, // Array penerima utama
      cc: values.Cc, // Array penerima CC
      subject: values.Subject,
      desc: values.description,
      file: values.NamaFile,
    };

    mutationAdd.mutate(memoData, {
      onSuccess: async (data, context) => {
        toast.success(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShowModalAdd(false);
        setShowModalEdit(false);
        mutation.mutate({
          start: start,
          count: count,
          search: search,
        });
      },
      onError: async (data, context) => {
        toast.error(data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      },
    });
  };

  const filterApi = () => {
    const formData = {
      start: start,
      count: count,
      search: "",
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      user: authUser, // Kirim user ID ke backend
      showall: "false", // Default hanya tampilkan memo terkait user
    };
    mutation.mutate(formData);
  };

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
    dispatch(getMinKaryawan({ search: "" }));
  }

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  // ── Data list (client-side search + sort desc + pagination) ──
  const PAGE_SIZE = 10;
  const [searchQuery, setSearchQuery] = useState("");

  const allMemo = useMemo(() => {
    const d = mutation.data?.data;
    return Array.isArray(d) ? d : [];
  }, [mutation.data]);

  const fmtDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);
    return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("id-ID");
  };
  const statusText = (a) => (a === 99 ? "Close" : a === 0 ? "Progress" : "Open");
  const toNames = (r) =>
    Array.isArray(r.ToList) ? r.ToList.map((x) => x.Name || "").join(", ") : r.To || "";
  const ccNames = (r) =>
    Array.isArray(r.CcList) ? r.CcList.map((x) => x.Name || "").join(", ") : r.Cc || "";

  const filteredMemo = useMemo(() => {
    let rows = [...allMemo];
    const kw = searchQuery.trim().toLowerCase();
    if (kw) {
      rows = rows.filter((r) =>
        [r.NoMemo, r.NomorMemo, r.From, toNames(r), ccNames(r), r.Subject, r.CreatedBy, statusText(r.Approved)]
          .some((v) => v && v.toString().toLowerCase().includes(kw))
      );
    }
    rows.sort((a, b) => {
      const ta = a.Date ? new Date(a.Date).getTime() : 0;
      const tb = b.Date ? new Date(b.Date).getTime() : 0;
      return tb - ta;
    });
    return rows;
  }, [allMemo, searchQuery]);

  const totalPage = Math.max(1, Math.ceil(filteredMemo.length / PAGE_SIZE));
  const safePage = Math.min(page || 1, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filteredMemo.slice(s, s + PAGE_SIZE);
  }, [filteredMemo, safePage]);

  useEffect(() => {
    setPage(1);
  }, [searchQuery, mutation.data]);

  const handleSearchChange = useCallback((e) => {
    setSearchQuery(typeof e === "string" ? e : e?.target?.value || "");
  }, []);

  // Aksi per-baris (mirror TableMemo): Balas bila status -1/0 & user From/To; View selalu.
  const isFromRow = (r) => String(r.FromNik || "").trim() === String(authUser || "").trim();
  const isToRow = (r) => {
    if (!r.ToNik) return false;
    let arr = r.ToNik;
    if (typeof arr === "string") {
      try {
        arr = JSON.parse(arr);
      } catch (e) {
        return String(r.ToNik).trim() === String(authUser || "").trim();
      }
    }
    if (Array.isArray(arr)) return arr.map((x) => String(x || "").trim()).includes(String(authUser || "").trim());
    return String(arr).trim() === String(authUser || "").trim();
  };

  // ── Export ─────────────────────────────────────────────────
  const exportHeaderMemo = [
    "No", "Memo Number", "From", "To", "Cc", "Start Date", "Subject", "Created By", "Status",
  ];
  const buildExportBody = () =>
    filteredMemo.map((r, i) => [
      i + 1,
      r.NoMemo || r.NomorMemo || "-",
      r.From || "-",
      toNames(r) || "-",
      ccNames(r) || "-",
      fmtDate(r.Date),
      r.Subject || "-",
      r.CreatedBy || "-",
      statusText(r.Approved),
    ]);
  const handleExportExcel = () =>
    downloadExcel({
      fileName: "Internal_Memo",
      sheet: "data",
      tablePayload: { header: exportHeaderMemo, body: buildExportBody() },
    });
  const handleExportPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(12);
    doc.text("Internal Memo", 14, 14);
    autoTable(doc, {
      head: [exportHeaderMemo],
      body: buildExportBody(),
      startY: 20,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
    });
    doc.save("Internal_Memo.pdf");
  };

  const statusClass = (a) =>
    a === 99
      ? "bg-green-100 text-green-800"
      : a === 0
      ? "bg-yellow-100 text-yellow-800"
      : "bg-blue-100 text-blue-800";

  const colHeaderMemo = [
    "No", "Memo Number", "From", "To", "Cc", "Tanggal", "Subject", "Created By", "Status", "Actions",
  ];

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {/* ── Filter row (periode) ── */}
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-4 py-3 gap-4">
                  <div className="w-full sm:w-1/4">
                    <HrdInputGenerator
                      type={"bulan"}
                      name={"Bulan"}
                      title={"Periode"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      &nbsp;
                    </label>
                    <button
                      type="button"
                      onClick={filterApi}
                      className="h-[42px] text-main-100 hover:text-white border border-main-100 hover:bg-main-100 font-medium rounded-lg text-sm px-7 text-center"
                    >
                      Buka
                    </button>
                  </div>
                </div>

                {mutation.isLoading ? (
                  <div className="w-full pt-0">
                    <Skeltons />
                  </div>
                ) : (
                  <>
                    {/* ── Toolbar: Tambah / Export / Search ── */}
                    <div className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2 gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={ClickAdd}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-main-100 hover:bg-main-100 hover:text-white rounded shadow"
                        >
                          Tambah Memo +
                        </button>
                        <button
                          onClick={handleExportExcel}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-green-600 hover:bg-green-600 hover:text-white rounded shadow"
                        >
                          Download Excel
                        </button>
                        <button
                          onClick={handleExportPDF}
                          className="flex items-center justify-center my-1 sm:my-0 bg-white text-gray-800 font-semibold py-2 px-4 border border-red-400 hover:bg-red-400 hover:text-white rounded shadow"
                        >
                          Download PDF
                        </button>
                      </div>
                      <div className="flex flex-row w-96">
                        <input
                          type="text"
                          placeholder="Cari No Memo / Subject / From / To"
                          value={searchQuery}
                          onChange={handleSearchChange}
                          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                        />
                      </div>
                    </div>

                    {/* ── Tabel ── */}
                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {colHeaderMemo.map((h, i) => (
                              <th key={i} scope="col" className="py-3 px-6">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr>
                              <td colSpan={colHeaderMemo.length} className="text-center py-8 text-gray-400">
                                {searchQuery ? `Tidak ada data untuk "${searchQuery}"` : "Tidak ada data memo"}
                              </td>
                            </tr>
                          ) : (
                            pageRows.map((row, id) => {
                              const showBalas =
                                (row.Approved === -1 || row.Approved === 0) &&
                                (isFromRow(row) || isToRow(row));
                              return (
                                <tr
                                  key={row.ID || id}
                                  className={id % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}
                                >
                                  <td className="py-4 px-6">{(safePage - 1) * PAGE_SIZE + id + 1}</td>
                                  <td className="py-4 px-6 whitespace-nowrap font-mono text-xs">
                                    {row.NoMemo || row.NomorMemo || "-"}
                                  </td>
                                  <td className="py-4 px-6">{row.From || "-"}</td>
                                  <td className="py-4 px-6">{toNames(row) || "-"}</td>
                                  <td className="py-4 px-6">{ccNames(row) || "-"}</td>
                                  <td className="py-4 px-6 whitespace-nowrap">{fmtDate(row.Date)}</td>
                                  <td className="py-4 px-6">{row.Subject || "-"}</td>
                                  <td className="py-4 px-6">{row.CreatedBy || "-"}</td>
                                  <td className="py-4 px-6">
                                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass(row.Approved)}`}>
                                      {statusText(row.Approved)}
                                    </span>
                                  </td>
                                  <td className="py-4 px-6 whitespace-nowrap">
                                    <div className="flex gap-2">
                                      {showBalas && (
                                        <button
                                          onClick={() => navigate(`/memo/internalmemodetail/action/${row.ID}`)}
                                          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded shadow text-sm"
                                        >
                                          Balas
                                        </button>
                                      )}
                                      <button
                                        onClick={() => navigate(`/memo/internalmemodetail/view/${row.ID}`)}
                                        className="bg-gray-500 hover:bg-gray-600 text-white font-semibold py-1 px-3 rounded shadow text-sm"
                                      >
                                        View
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* ── Info + Pagination ── */}
                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filteredMemo.length} data</span>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => setPage((p) => Math.max(1, (p || 1) - 1))}
                          disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Prev
                        </button>
                        <span>Page {safePage} / {totalPage}</span>
                        <button
                          onClick={() => setPage((p) => Math.min(totalPage, (p || 1) + 1))}
                          disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        fullscreen={true}
        active={showModalAdd}
        toggler={() => {
          setShowModalAdd(true);
        }}
      >
        <ModalHeader
          className="mt-20"
          toggler={() => {
            setShowModalAdd(false);
            setShowModalEdit(false);
            setButtonTouched(false);
            clearHandler();
          }}
        >
          {showModalEdit ? "Edit Data" : "Tambah Data"}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg" onSubmit={submitHandler}>
            <HrdInputGenerator
              type={"multipleSelect"}
              value={values}
              name={"to"}
              title={"To"}
              onChange={changeArrayHandler} // Using changeArrayHandler for multiple select
              touched={touched}
              buttonTouched={buttonTouched}
              size={"full"}
              required={true}
              errors={errors}
              disabled={false}
            />

            <HrdInputGenerator
              type={"multipleSelect"}
              value={values}
              currentData={currentData}
              name={"Cc"}
              title={"Cc"}
              onChange={changeArrayHandler}
              touched={touched}
              buttonTouched={buttonTouched}
              size={"full"}
              required={true}
              errors={errors}
              disabled={false}
            />

            <div className={"w-full px-3 mb-6"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Subject *
              </label>
              <input
                value={values.Subject}
                onChange={changeHandler}
                name="Subject"
                className={
                  (touched.Subject || buttonTouched) && errors.Subject
                    ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                }
                type="text"
                disabled={showModalEdit ? true : false}
              />
            </div>

            <div className={"w-full px-3 mb-6"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-6">
                {values["NamaFile"] && "Ganti "}
                Attachment
              </label>
              <label
                htmlFor={"NamaFile"}
                className="block w-full border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              >
                {values["NamaFile"] ? (
                  <span>
                    File Selected -{" "}
                    {values["NamaFile"].name
                      ? values["NamaFile"].name
                      : values["NamaFile"]}
                  </span>
                ) : (
                  <span>Choose a file...</span>
                )}
              </label>

              <input
                type="file"
                id={"NamaFile"}
                key={"NamaFile"}
                name={"NamaFile"}
                style={{ visibility: "hidden" }}
                className="block  border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                onChange={(e) => {
                  customHandler(e.target.files[0], "NamaFile");
                }}
              />
            </div>
            <div className={"w-full px-3 mb-6"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Description
              </label>
              <TextEditor
                onClick={changeHandler}
                onChange={(e) =>
                  customHandler(
                    draftToHtml(convertToRaw(e.getCurrentContent())),
                    "description"
                  )
                }
              />
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              setShowModalAdd(false);
              setShowModalEdit(false);
              clearHandler();
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color={
              isValid || (showModalEdit && dateChanged && !isValid)
                ? "green"
                : "blueGray"
            }
            onClick={() => Kirim()}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default MemoPage;
